import { API } from "../../apiEndPoints/website/apiEndPoints";
import {
  axiosDelete,
  axiosPost,
} from "../../axios/axiosMiddleware";
import createAxiosInstance, { axiosGet2, axiosPatch, axiosPost2 } from "../../axios/axiosMiddleware2";
import { store } from "../../redux/store";
const axiosInstance = createAxiosInstance(store);
export const getPiecesList = (queryString: String) => {
  return axiosGet2(axiosInstance,`${API?.OTHER?.PIECES}${queryString}`);
};

export const deletePiecesList = (id: number) => {
  return axiosDelete(`${API?.OTHER?.DELETE_FEED}/${id}`);
};

export const editArt = (data: any, id: any) => {
  return axiosPatch(axiosInstance,`${API?.OTHER?.GET_ARTROOM_DETAILS}/${id}`, data);
};

export const createPost = (data: any) => {
  return axiosPost2(axiosInstance,`${API?.OTHER?.CREATE_POST}`, data);
};

export const createPostVideo = (data: any) => {
  return axiosPost2(axiosInstance,`${API?.OTHER?.CREATE_POST_VIDEO}`, data);
};
export const createArtroomPostVideo = (data: any) => {
  return axiosPost2(axiosInstance,`${API?.OTHER?.CREATE_ARTROOM_VIDEO}`, data);
};

export const createArtroomPost = (data: any) => {
  return axiosPost2(axiosInstance,`${API?.OTHER?.CREATE_ARTROOM_POST}`, data);
};

export const createPostText = (data: any) => {
  return axiosPost(`${API?.OTHER?.CREATE_POST_TEXT}`, data);
};
